import React, { useEffect, useRef, useState } from 'react';
import { FaHeart, FaRecycle } from 'react-icons/fa6';
import { GiMiningHelmet } from 'react-icons/gi';
import { PiTreePalmFill } from 'react-icons/pi';


const HomepageComp5 = () => {

    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);

    return (
        <div className={`homepage-component-container homepage-comp5-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>
            <div className='px-8'>
                <div className='grid grid-cols-2 gap-4'>
                    <h1 className='homepage-title2'>Explore Eco-Friendly Gold Mining with Merge Turk Gold</h1>
                    <p className='homepage-text3'>Merge Turk Gold delivers innovative mining solutions that respect the environment while extracting the precious resources you need.</p>
                </div>
                <div className='grid grid-cols-3 gap-4'>
                    <div className='homepage-comp5-card'>
                        <div className='homepage-img6 relative'>
                            <div className='homepage-comp4-icon'>
                            <FaRecycle />
                            </div>
                        </div>
                        <h2 className='homepage-title3'>Sustainable Alluvion Mining</h2>
                        <p className='homepage-text2 m-0'>Our advanced alluvion mining techniques minimize ecological impact while ensuring maximum recovery of gold, safeguarding nature’s balance.</p>
                    </div>
                    
                    <div className='homepage-comp5-card'>
                        <div className='homepage-img7 relative'>
                            <div className='homepage-comp4-icon'>
                            <GiMiningHelmet />
                            </div>
                        </div>
                        <h2 className='homepage-title3'>Innovative Rock Mining Solutions</h2>
                        <p className='homepage-text2 m-0'>Leveraging state-of-the-art technology, we ensure safe extraction from rock deposits while minimizing environmental footprints.</p>
                    </div>
                    
                    <div className='homepage-comp5-card'>
                        <div className='homepage-img8 relative'>
                            <div className='homepage-comp4-icon'>
                            <FaHeart />
                            </div>
                        </div>
                        <h2 className='homepage-title3'>Commitment to Community</h2>
                        <p className='homepage-text2 m-0'>We enhance local economies through job opportunities and responsible practices, promising a sustainable future for generations to come.</p>
                    </div>
                </div>

            </div>
        </div>


    )
}

export default HomepageComp5